module.exports = __webpack_public_path__ + "img/45_27.0ec68fad.png";